import { ColorPickerConfig } from './generic-colorpicker.component';
import { COLOR_PRESETS } from '@shared/utils/color-utils';

export const CENTER_TAG_COLOR_CONFIG: ColorPickerConfig = {
  format: 'hex',
  placeholder: 'Nhập màu nền thẻ (ví dụ: #ff0000)',
  showContrastButton: false,
  dependsOn: 'colorPreset',
  onDependencyChange: (dependencyValue: any) => {
    // If no preset is selected, return null to clear the color
    if (!dependencyValue) {
      return null;
    }

    // Find the selected preset and return its tagColor
    const selectedPreset = COLOR_PRESETS.find(preset => preset.value === dependencyValue);
    return selectedPreset ? selectedPreset.tagColor : null;
  }
};

export const CENTER_TAG_TEXT_COLOR_CONFIG: ColorPickerConfig = {
  format: 'hex',
  placeholder: 'Nhập màu chữ hoặc dùng nút tạo màu tương phản',
  showContrastButton: true,
  contrastSourceField: 'tagColor',
  dependsOn: 'colorPreset',
  onDependencyChange: (dependencyValue: any) => {
    // If no preset is selected, return null to clear the color
    if (!dependencyValue) {
      return null;
    }

    // Find the selected preset and return its tagTextColor
    const selectedPreset = COLOR_PRESETS.find(preset => preset.value === dependencyValue);
    return selectedPreset ? selectedPreset.tagTextColor : null;
  }
};

// Default configs for general use (without Vietnamese text)
export const DEFAULT_TAG_COLOR_CONFIG: ColorPickerConfig = {
  format: 'hex',
  placeholder: 'Enter tag background color (e.g., #ff0000)',
  showContrastButton: false,
  dependsOn: 'colorPreset',
  onDependencyChange: (dependencyValue: any) => {
    // If no preset is selected, return null to clear the color
    if (!dependencyValue) {
      return null;
    }

    // Find the selected preset and return its tagColor
    const selectedPreset = COLOR_PRESETS.find(preset => preset.value === dependencyValue);
    return selectedPreset ? selectedPreset.tagColor : null;
  }
};

export const DEFAULT_TAG_TEXT_COLOR_CONFIG: ColorPickerConfig = {
  format: 'hex',
  placeholder: 'Enter text color or use contrast button',
  showContrastButton: true,
  contrastSourceField: 'tagColor',
  dependsOn: 'colorPreset',
  onDependencyChange: (dependencyValue: any) => {
    // If no preset is selected, return null to clear the color
    if (!dependencyValue) {
      return null;
    }

    // Find the selected preset and return its tagTextColor
    const selectedPreset = COLOR_PRESETS.find(preset => preset.value === dependencyValue);
    return selectedPreset ? selectedPreset.tagTextColor : null;
  }
};